export const appVersionsFileName = 'appVersions.json';

export const MicroFrontendsHosts = {
	test: 'https://mfs.efrtest.ru',
	cert: 'https://mfs.efrcert.ru',
	prod: 'https://mfs.efr.ru',
};

export const StaticHosts = {
	test: 'https://static-img.ru',
	cert: 'https://static-img.ru',
	prod: 'https://static-img.ru',
};

export const LocalizationHosts = {
	test: `${StaticHosts.test}/dictionary/web`,
	cert: `${StaticHosts.cert}/dictionary/web`,
	prod: `${StaticHosts.prod}/dictionary/web`,
};
export const appVersionsHost = {
	test: `${MicroFrontendsHosts.test}/${appVersionsFileName}`,
	cert: `${MicroFrontendsHosts.cert}/${appVersionsFileName}`,
	prod: `${MicroFrontendsHosts.prod}/${appVersionsFileName}`,
};

export const appReviewHost = {
	test: 'https://review.efrtest.ru',
	cert: 'https://review.efrcert.ru',
	prod: 'https://review.efrcert.ru',
};

export const CompanyDomains = [
	'efin.ru',
	'efr.ru',
	'efrtest.ru',
	'efrcert.ru',
	'efintest.ru',
	'efincert.ru',
];
